import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-AggRotacionUsu', 
    styleUrls: ['./aggRotacionUsu.component.css'], 
    templateUrl: './aggRotacionUsu.component.html'
    

})

export class AggRotacionUsu implements OnInit{
    
    saldoF;
    retiros;


    constructor(){}

    ngOnInit(){}

}